<template>
  <div>
    <video autoplay muted loop id="blueVideo">
      <source src="https://tabbot-central.b-cdn.net/video/BlauerHintergrundPlatine.mp4" type="video/mp4">
    </video>
    <div class="blue-container">
      <Header />
      <div class="content-container">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col my-auto">
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-8 col-lg-6">
                  <h2>{{ $t('login.headline') }}</h2>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-8 col-lg-6 pt-3">
                  <div class="error pb-3" v-if="loginError">
                    <div class="text-danger" v-if="errorType === 'missingTeamName'">
                      {{ $t('login.error.missingTeamName') }}
                    </div>
                    <div class="text-danger" v-if="errorType === 'wrongPassword'">
                      {{ $t('login.error.wrongPassword') }}
                    </div>
                    <div class="text-danger" v-if="errorType === 'couldNotStartChapter'">
                      {{ $t('login.error.couldNotStartChapter') }}
                    </div>
                    <div class="text-danger" v-if="errorType === 'couldNotLoginUser'">
                      {{ $t('login.error.couldNotLoginUser') }}
                    </div>
                  </div>
                  <form>
                    <div class="form-group">
                      <input type="input" class="form-control text-center" id="teamname" v-model="teamname" :placeholder="$t('login.placeholder-team')" />
                    </div>
                    <div class="form-group">
                      <input type="password" class="form-control text-center" id="password" v-model="password" :placeholder="$t('login.placeholder-password')" />
                    </div>
                    <div>
                      <button class="btn btn-primary btn-block text-center" @click="doLogin">{{ $t('login.button-primary') }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      pw: 'asdkfjhtmnbvasdfknedsfDSF',
      username: '',
      teamname: '',
      password: '',
      loginPassword: '239',
      loginError: false,
      errorType: ''
    }
  },
  components: {
    Header, Footer
  },
  methods: {
    doLogin: function (event) {
      event.preventDefault()
      // Alle Cookies loeschen
      const cookies = document.cookie.split('; ').reduce((prev, current) => {
        const [name, value] = current.split('=')
        prev[name] = value
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
        return prev
      }, {})

      this.errorType = ''
      this.loginError = false
      if (this.teamname.trim() === '') {
        this.loginError = true
        this.errorType = 'missingTeamName'
        return
      }
      if (this.password !== this.loginPassword) {
        this.loginError = true
        this.errorType = 'wrongPassword'
        return
      }
      const cookieDate = new Date()
      let expires = ';expires='
      cookieDate.setTime(cookieDate.getTime() + 86400000)
      expires += cookieDate.toGMTString()

      // TEAM NAMEN SPEICHERN
      this.$store.commit('setTeamname', this.teamname)
      // COOKIE MIT TEAM NAMEN SETZEN
      document.cookie = 'teamname=' + this.teamname + expires

      // USERNAME ERSTELLEN
      if (!this.username) {
        this.username = this.teamname + Math.random().toString(36).substring(7) + Date.now()
      }
      this.$store.commit('setUsername', this.username)
      document.cookie = 'username=' + this.username + expires

      // WRITE GAMEDATE INTO COOKIES
      const d = new Date()
      document.cookie = 'gamedate=' + d.getFullYear() + d.getMonth() + d.getDate() + expires

      // SEND USER TO BACKEND
      axios.get('http://admin.tabbot-central.com/userLogin.php', {
        params: {
          token: this.pw,
          username: this.username,
          teamname: this.teamname
        }
      }).then(this.startChapter1).catch(error => {
        console.log(error)
        this.errorType = 'couldNotLoginUser'
        this.loginError = true
      })
    },
    startChapter1: function () {
      // START CHAPTER 1
      axios.get('http://admin.tabbot-central.com/setTimer.php', {
        params: {
          token: this.pw,
          chapter: 1
        }
      }).then(response => {
        this.$store.commit('loggedIn')
      }).catch(error => {
        console.log(error)
        this.errorType = 'couldNotStartChapter'
        this.loginError = true
      })
    }
  }
}
</script>
